<script setup lang="ts">
import {useKlModalEventsUtil} from '@/app/shared/helpers/kl-modal-events-util';

const emit = defineEmits(['goto-shoppingcart']);

const modalId = 'submitted-shoppingcart-error-modal';
const modalEvents = useKlModalEventsUtil(modalId);

function goToShoppingCart() {
    emit('goto-shoppingcart');
}
</script>

<template>
    <vl-modal :id="modalId" open>
        <vl-title tag-name="h3">Planaanvraag kan niet gemaakt worden</vl-title>
        <vl-typography>
            Voltooi of annuleer de betaling van uw winkelmandje voor u een nieuwe planaanvraag toevoegt.
        </vl-typography>
        <template v-slot:modal-footer>
            <vl-action-group>
                <vl-button @click="goToShoppingCart" v-vl-modal-toggle="modalId">
                    Naar winkelmandje
                </vl-button>
            </vl-action-group>
        </template>
    </vl-modal>
</template>

<style scoped lang="scss">

</style>
